import { SearchFilters } from "../../types/v1_schemas";

/**
 * Helper function to remove empty strings from an array
 * @param values
 * @returns
 */
export function removeEmpty(values: string[]) {
  return values.filter(([val]) => val && val.length > 0);
}

export function toggleItemInList(list: any[], item: any) {
  // remove an item if it's in the list
  // or add it if it isn't
  return list.includes(item)
    ? list.filter((val) => val !== item)
    : [...list, item];
}

export function toggleItemInRadioList(list: any[], item: string) {
  // remove an item if it's in the list
  // or add it if it isn't

  if (list.length === 0) {
    // list is empty, add value
    return [...list, item];
  } else {
    // list is not empty
    if (list.includes(item)) {
      // list contains item, send back empty list
      return list.splice(0,list.length);
    } else {
      // list does not include item, but includes another value, send back array with new item
      list.length = 0;
      list.push(item);
      return list;
    }
  }
}

export function toggleItemInFilterList(list: any[], item: string) {
  // remove an item if it's in the list
  // or add it if it isn't
  return list.includes(item)
    ? list.filter((val) => val !== item)
    : [...list, item];
}

export function toggleDayFilters(
  filters: SearchFilters,
  option: string
) {

  switch(option)
  {
    case "Sunday": 
      if (filters.openSunday && filters.openSunday.length) {
        filters.openSunday = "";
      } else {
        filters.openSunday = "true";
      }
      break;
    
    case "Monday": 
      if (filters.openMonday && filters.openMonday.length) {
        filters.openMonday = "";
      } else {
        filters.openMonday = "true";
      }
      break;
    
    case "Tuesday": 
      if (filters.openTuesday && filters.openTuesday.length) {
        filters.openTuesday = "";
      } else {
        filters.openTuesday = "true";
      }
      break;

    case "Wednesday": 
      if (filters.openWednesday && filters.openWednesday.length) {
        filters.openWednesday = "";
      } else {
        filters.openWednesday = "true";
      }
      break;

    case "Thursday": 
      if (filters.openThursday && filters.openThursday.length) {
        filters.openThursday = "";
      } else {
        filters.openThursday = "true";
      }
      break;

    case "Friday": 
      if (filters.openFriday && filters.openFriday.length) {
        filters.openFriday = "";
      } else {
        filters.openFriday = "true";
      }
      break;

    case "Saturday": 
      if (filters.openSaturday && filters.openSaturday.length) {
        filters.openSaturday = "";
      } else {
        filters.openSaturday = "true";
      }
      break;
  }

    if (!filters.openSunday) delete filters.openSunday;
    if (!filters.openMonday) delete filters.openMonday;
    if (!filters.openTuesday) delete filters.openTuesday;
    if (!filters.openWednesday) delete filters.openWednesday;
    if (!filters.openThursday) delete filters.openThursday;
    if (!filters.openFriday) delete filters.openFriday;
    if (!filters.openSaturday) delete filters.openSaturday;
    if (!filters.displayNameFilter) delete filters.displayNameFilter

    return filters;
}